import React, { Component } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import HeaderDash from "../Header";
import MenuDrawer from "../MenuDrawer";

// 1. HOC para permitir o uso do Hook useAuth em um Componente de Classe
function withAuth(WrappedComponent) {
  return function WithAuthWrapper(props) {
    const auth = useAuth();
    return <WrappedComponent {...props} auth={auth} />;
  };
}

// 2. Componente de Classe
class ProtectedRouteClass extends Component {
  socket = null;

  componentDidMount() {
    const { isAuthenticated } = this.props.auth;
    console.log('teste')

  }





  render() {
    const { isAuthenticated } = this.props.auth;

    if (!isAuthenticated) {
      return <Navigate to="/auth/login" replace />;
    }

    return (
      <MenuDrawer>
        <Outlet />
      </MenuDrawer>
    );
  }
}

// Exporta o componente envolvido pelo HOC
export default withAuth(ProtectedRouteClass);